import actions from 'src/modules/planificadorTareaCustom/importer/planificadorTareaCustomImporterActions';
import importerReducers from 'src/modules/shared/importer/importerReducers';

export default importerReducers(actions);
